import React from 'react'
import DownloadIcon from '@mui/icons-material/Download'
import { Button, Tooltip, CircularProgress } from '@mui/material'

interface DownLoadButtonProps {
  onClick: () => void
  disabled?: boolean
  isLoading?: boolean
}

const DataTableDownLoadButton = ({ onClick, disabled, isLoading }: DownLoadButtonProps) => {
  return (
    <Tooltip title="Télécharger CSV">
      <span>
        <Button
          onClick={onClick}
          className="text-white"
          sx={{ color: 'white' }}
          disabled={disabled}
        >
          {isLoading ? <CircularProgress size={18} color="inherit" /> : <DownloadIcon />}
        </Button>
      </span>
    </Tooltip>
  )
}

export default DataTableDownLoadButton
